import React from "react";
import { API } from "../lib/api";
import { FileText } from "lucide-react";

export default function FileViewer({ file, className = "" }) {
  if (!file) return null;
  const src = `${API}/files/${file.id}/view`;

  if (file.kind === "image") {
    return <img src={src} alt={file.title} className={`max-h-[75vh] w-auto max-w-full object-contain ${className}`} data-testid="viewer-image" />;
  }
  if (file.kind === "video") {
    return (
      <video
        src={src}
        controls
        controlsList="nodownload noremoteplayback"
        disablePictureInPicture
        className={`max-h-[75vh] w-full ${className}`}
        data-testid="viewer-video"
      />
    );
  }
  if (file.kind === "audio") {
    return <audio src={src} controls controlsList="nodownload" className={`w-full ${className}`} data-testid="viewer-audio" />;
  }
  if (file.kind === "pdf" || file.kind === "text") {
    return (
      <iframe
        src={src}
        title={file.title}
        className={`h-[75vh] w-full border-0 bg-white ${className}`}
        data-testid="viewer-frame"
      />
    );
  }
  // Office docs and other formats — browsers can't reliably render these inline.
  return (
    <div className={`flex flex-col items-center justify-center gap-3 border border-edge bg-ash p-12 text-center ${className}`} data-testid="viewer-unsupported">
      <FileText className="h-10 w-10 text-gold" />
      <p className="font-serif text-xl text-bone">{file.original_filename}</p>
      <p className="max-w-sm text-sm text-muted">
        This document type can't be previewed in the browser. For in-browser viewing, upload materials as PDF.
      </p>
    </div>
  );
}
